import { StorageMeterComponent } from "./storage-meter/storage-meter.component";

export const ACCOUNT_COMPONENTS = [StorageMeterComponent];

export * from "./storage-meter/storage-meter.component";
